import requestService from "api/request";
import { useDebounce } from "hooks/useDebounce";
import { formatNumber } from "lib/helpers/format";
import React, { useEffect, useState, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useInView } from "react-intersection-observer";
import { useNavigate } from "react-router-dom";

const ListCoinTrading = (props: any) => {
  const { className, setOpenListCoin } = props;
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [tokens, setTokens] = useState([]);
  const { ref, inView } = useInView({ threshold: 0.5 });
  const debounceValue = useDebounce(searchTerm, 300);
  const navigate = useNavigate();
  const {t} = useTranslation()

  const getTokens = useCallback(async (debounceValue: void, page: number) => {
    try {
      const res = await requestService.get(
        `/guest/tokens?filter=${debounceValue}&limit=10&page=${page}`
      );
      if (res && res.data) {
        const data = res.data.data;
        if (data.tokens.length === 0) {
          setHasMore(false);
        } else {
          setTokens((prevTokens) =>
            page === 1 ? data.tokens : [...prevTokens, ...data.tokens]
          );
        }
      }
    } catch (error) {
      console.log(error);
    }
  }, []);

  useEffect(() => {
    setPage(1);
    setHasMore(true);
    setTokens([]);
  }, [debounceValue]);

  useEffect(() => {
    if (hasMore) {
      getTokens(debounceValue, page);
    }
  }, [debounceValue, page, getTokens, hasMore]);

  useEffect(() => {
    if (inView && hasMore) {
      setPage((prevPage) => prevPage + 1);
    }
  }, [inView, hasMore]);

  const onSearch = (value: string) => {
    setSearchTerm(value);
  };

  return (
    <div className={`px-[16px] py-0 text-[#ccc] ${className}`}>
      <div className="h-auto flex items-center justify-start  px-[16px] py-[11px] border rounded-[100px] boder-[#27282B]">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="currentColor"
          aria-hidden="true"
          className="!w-[20px] !h-[20px] !me-[8px]"
        >
          <path d="M21.53 20.47l-4.694-4.694a8.26 8.26 0 10-1.06 1.06l4.693 4.695a.75.75 0 001.062-1.062zM3.75 10.5a6.75 6.75 0 116.75 6.75 6.758 6.758 0 01-6.75-6.75z"></path>
        </svg>
        <input
          type="text"
          placeholder={t("Tìm kiếm")}
          value={searchTerm}
          onChange={(e) => onSearch(e.target.value)}
          className="bg-transparent border-none outline-none w-full flex-1"
        ></input>
        <span
          className={`${
            searchTerm ? "cursor-pointer block" : "bit-input-clear-icon hidden"
          }`}
          onClick={() => onSearch("")}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            aria-hidden="true"
            style={{ width: "1em", height: "1em" }}
          >
            <path d="M12 2.25A9.75 9.75 0 1021.75 12 9.76 9.76 0 0012 2.25zm3.53 12.22a.75.75 0 11-1.06 1.06L12 13.06l-2.47 2.47a.75.75 0 11-1.06-1.06L10.94 12 8.47 9.53a.75.75 0 011.06-1.06L12 10.94l2.47-2.47a.751.751 0 011.06 1.06L13.06 12l2.47 2.47z"></path>
          </svg>
        </span>
      </div>
      <div className="mt-4 flex flex-col w-full">
        <div className="item flex xl:gap-3">
          <span className="flex-1 pl-3">Coin</span>
          <span className="flex-1 text-right">{t("Giá gần nhất")}</span>
          <span className="flex-1 pr-2 text-right">{t("Biến động 24h")}</span>
        </div>
        <div className="mt-2 flex flex-col w-full overflow-auto h-[380px] xl:h-[390px]">
          {tokens.map((item: any, index) => (
            <div
              key={index}
              className="item flex py-2 xl:gap-3 hover:bg-[#1F2023] cursor-auto"
              onClick={() => {
                setOpenListCoin(false);
                navigate(`/trading?spot=${item.symbol}`);
              }}
            >
              <div className="flex-1 pl-2 font-medium">
                <div className="flex gap-1">
                  <div className="w-6 h-6">
                    <img
                      width={20}
                      height={20}
                      className="Q13rdX33uJYEoE3CzRsA me-[8px]"
                      src={`https://s2.coinmarketcap.com/static/img/coins/64x64/${item?.id}.png`}
                    />
                  </div>
                  <span>{item.symbol}/USDT</span>
                </div>
              </div>
              <span className="flex-1 text-right">
                {formatNumber(item.quote.USD.price.toFixed(4)) ?? ""}
              </span>
              <span
                className={`flex-1 pr-2 text-right ${
                  item.quote.USD.percent_change_24h < 0
                    ? "text-[#f1493f]"
                    : "text-[#01bc8d]"
                }`}
              >
                {formatNumber(item.quote.USD.percent_change_24h.toFixed(2)) ??
                  ""}
                %
              </span>
            </div>
          ))}
          <div ref={ref} className="h-1" />
        </div>
      </div>
    </div>
  );
};

export default ListCoinTrading;
